import type { BrandingConfig, LogoConfig } from 'config-types/config/branding';

const BRANDING_DATA: BrandingConfig = {
  projectName: 'Xpress Urgent Care',
  projectDomain: 'xurgentcare.com',
  email: {
    logoURL:
      'http://cdn.mcauto-images-production.sendgrid.net/978880ba6bbd1598/213bc6aa-4785-4841-b18e-377597c260f1/450x158.png',
    palette: {
      deemphasizedText: '#00000061',
      headerText: '#0F347C',
      bodyText: '#000000DE',
      footerText: '#212130',
      buttonColor: '#295F75',
    },
    sender: 'hello@xurgentcare.com',
    replyTo: 'hello@xurgentcare.com',
  },
  logo: {
    default: '',
    email: '',
    pdf: '',
  },
  intake: {
    primaryIconAlt: 'Xpress Cross Icon',
    welcomeTitleBreak: true,
    primaryIconSize: 125,
    primaryIconVisibility: { default: false, pages: { walkinLanding: true } },
    appBar: {
      backgroundColor: '#FFF',
      logoHeight: '32px',
      logoutButtonTextColor: '#0F347C',
    },
    assets: {
      logo: '/intakeLogo.png',
      primaryIcon: '/primaryIcon.svg',
    },
    theme: {
      otherColors: {
        emergencyBanner: '#CB0E14',
        purple: '#0F347C',
        lightBlue: '#0F347C1A',
      },
      palette: {
        primary: {
          light: '#0F347C',
        },
        secondary: {
          main: '#0F347C',
        },
        background: {
          default: '#F4F6F8',
        },
      },
    },
  },
};

export const BRANDING_CONFIG = Object.freeze(BRANDING_DATA);

// Derived constant - defined here to avoid circular dependencies
// (types/constants.ts cannot import from ottehr-config without creating a cycle)
export const PROJECT_WEBSITE = `https://${BRANDING_CONFIG.projectDomain}`;

type LogoTarget = Exclude<keyof LogoConfig, 'default'>;

export function getLogoFor(target: LogoTarget): string | undefined {
  const { logo } = BRANDING_CONFIG;

  return logo?.[target] || logo?.default;
}
